export default "__VITE_ASSET__3da0ec82__"